class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.grid = this.querySelector('[data-recently-viewed-grid]');
    this.currentHandle = this.dataset.currentHandle;
    this.max = parseInt(this.dataset.max, 10) || 4;
    this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
    this.render();
  }

  getHandles() {
    let stored = [];
    try {
      stored = JSON.parse(window.localStorage.getItem('recently_viewed')) || [];
    } catch (e) {
      stored = [];
    }
    return stored.filter((handle) => handle !== this.currentHandle).slice(0, this.max);
  }

  async render() {
    const handles = this.getHandles();
    if (!handles.length || !this.grid) return;

    const products = await Promise.all(
      handles.map((handle) =>
        fetch(`/products/${handle}.js`)
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null)
      )
    );

    const validProducts = products.filter(Boolean);
    if (!validProducts.length) return;

    this.grid.innerHTML = validProducts.map((product) => this.renderCard(product)).join('');
    this.hidden = false;
  }

  renderCard(product) {
    const image = product.featured_image;
    const price = this.formatMoney(product.price);
    return `
      <li>
        <a href="${product.url}" class="recently-viewed__card">
          <span class="recently-viewed__image-wrap">
            ${image ? `<img src="${image}" alt="${this.escapeHtml(product.title)}" loading="lazy" width="300" height="300">` : ''}
          </span>
          <p class="recently-viewed__title">${this.escapeHtml(product.title)}</p>
          <p class="recently-viewed__price">${price}</p>
        </a>
      </li>
    `;
  }

  formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const amountNoDecimals = Math.round(cents / 100).toString();
    return this.moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amountNoDecimals);
  }

  escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value;
    return div.innerHTML;
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
